import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoriesOpen, setCategoriesOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-background-200 shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="font-heading text-xl font-semibold text-foreground-900 tracking-tight">
            Basetao<span className="text-primary-500">Sheet</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-sm font-semibold text-foreground-800 hover:text-primary-500 transition-colors whitespace-nowrap">
            Home
          </Link>
          <Link to="/article/basetao-shopping-guide" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">
            Shopping Guide
          </Link>
          <Link to="/article/basetao-spreadsheet-guide" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">
            Complete Guide
          </Link>
          <Link to="/article/basetao-review-2026" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">
            Review
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-sm font-semibold bg-primary-500 text-white px-5 py-2 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-200 px-4 py-4 flex flex-col gap-1 max-h-[70vh] overflow-y-auto">
          <Link
            to="/"
            className="text-sm font-semibold text-foreground-800 hover:text-primary-500 transition-colors py-2.5 px-2 rounded-md hover:bg-background-100"
            onClick={() => setMobileOpen(false)}
          >
            <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
              <i className="ri-home-4-line"></i>
            </span>
            Home
          </Link>
          <Link
            to="/article/basetao-shopping-guide"
            className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2.5 px-2 rounded-md hover:bg-background-100"
            onClick={() => setMobileOpen(false)}
          >
            <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
              <i className="ri-book-open-line"></i>
            </span>
            Shopping Guide
          </Link>
          <Link
            to="/article/basetao-spreadsheet-guide"
            className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2.5 px-2 rounded-md hover:bg-background-100"
            onClick={() => setMobileOpen(false)}
          >
            <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
              <i className="ri-guide-line"></i>
            </span>
            Complete Guide
          </Link>
          <Link
            to="/article/basetao-review-2026"
            className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2.5 px-2 rounded-md hover:bg-background-100"
            onClick={() => setMobileOpen(false)}
          >
            <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
              <i className="ri-star-line"></i>
            </span>
            Basetao Review
          </Link>
          <Link
            to="/article/basetao-shipping-cost-guide"
            className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2.5 px-2 rounded-md hover:bg-background-100"
            onClick={() => setMobileOpen(false)}
          >
            <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
              <i className="ri-ship-line"></i>
            </span>
            Shipping Guide
          </Link>
          <Link
            to="/article/basetao-coupon-codes"
            className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2.5 px-2 rounded-md hover:bg-background-100"
            onClick={() => setMobileOpen(false)}
          >
            <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
              <i className="ri-coupon-line"></i>
            </span>
            Coupon Codes
          </Link>

          <button
            className="flex items-center justify-between w-full text-sm font-semibold text-foreground-800 py-2.5 px-2 rounded-md hover:bg-background-100"
            onClick={() => setCategoriesOpen(!categoriesOpen)}
          >
            <span>
              <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
                <i className="ri-grid-line"></i>
              </span>
              Shop Categories
            </span>
            <span className={`w-4 h-4 flex items-center justify-center transition-transform ${categoriesOpen ? 'rotate-180' : ''}`}>
              <i className="ri-arrow-down-s-line"></i>
            </span>
          </button>

          {categoriesOpen && (
            <div className="ml-4 pl-3 border-l-2 border-background-200 flex flex-col gap-0.5">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-600 hover:text-primary-500 transition-colors py-2 px-2 rounded-md hover:bg-background-100"
                  onClick={() => setMobileOpen(false)}
                >
                  {cat.name}
                </a>
              ))}
            </div>
          )}

          <div className="border-t border-background-200 pt-3 mt-2">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="block text-center text-sm font-semibold bg-primary-500 text-white px-5 py-2.5 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}